import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class IndexBloc {

    regionChannel = new Subject();
    regionCityChannel = new Subject();
    regionProvinceChannel = new Subject();
    repository = new IndexRepository();

    fetchRegion = async (query) => {
        this.regionChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchRegion(query).then((result) => {
                this.regionChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.regionChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchRegionProvince = async (query) => {
        this.regionProvinceChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionProvince(query).then((result) => {
            this.regionProvinceChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionProvinceChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRegionCity = async (query) => {
        this.regionCityChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionCity(query).then((result) => {
            this.regionCityChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionCityChannel.next({status: apiResponse.ERROR, data: error})
        })
    }


}

export default IndexBloc; 